class Talkie_Calendly {
    constructor(element) {
        this.element = element;

        this.updateIframeSrc();
    }

    updateIframeSrc() {
        // Poll for iframe until it loads
        let interval = setInterval(() => {
            let iframe = this.element.querySelector('.calendly-inline-widget iframe');
            if (iframe) {
                let src = iframe.getAttribute('src');
                if (src) {
                    // Get current URL without query string or hash fragment parameters and without domain
                    const currentUrl = window.location.pathname;
                    // Get user key from cookie
                    const userKey = this.getCookie('__ca__chat');

                    let newSrc = src + '&utm_term=' + currentUrl;
                    if (userKey) {
                        newSrc += '&utm_content=' + userKey;
                    }

                    // Add the query string to the src attribute
                    iframe.setAttribute('src', newSrc);

                    // Stop polling once the iframe is found and updated
                    clearInterval(interval);
                }
            }
        }, 100); // Check every 100ms
    }

    getCookie(name) {
        const cookies = document.cookie.split(';');

        for (let cookie of cookies) {
            const [cookieName, cookieValue] = cookie.trim().split('=');

            if (cookieName === name) {
                return decodeURIComponent(cookieValue);
            }
        }

        return null;
    }
}

document.addEventListener('DOMContentLoaded', () => {
    let elements = document.querySelectorAll('.js-calendly');

    if (!elements.length) {
        return;
    }

    elements.forEach((element) => {
        new Talkie_Calendly(element);
    })
});
